import { FC } from 'react';
// components
import BottleCapacityComponent from 'components/main/BottleCapacity/Add';

const AddBottleCapacity: FC = () => <BottleCapacityComponent />;

export default AddBottleCapacity;
